import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';

import {
  logChatbotConversationCreatedFromStartOver,
  logChatbotErrorMessageAppears,
  logChatbotSendMessage,
  logSearchResultsPresented,
  logSingleArticlePresented,
} from '../bi';
import { TRootState } from '../common/reducers';
import { generateAnswerSlice } from '../common/reducers/answerGeneration';
import { chatActions } from '../common/reducers/chat';
import { errorsSlice } from '../common/reducers/errors';
import { fieldActions } from '../common/reducers/field';
import { ResetReason } from '../common/reducers/types';
import { selectSolutions } from '../common/selectors/solutions';
import { loadArticleById, loadArticleByUri } from '../common/thunks/articles.thunk';
import { loadAttaches } from '../common/thunks/attaches.thunk';
import { loadSolutions } from '../common/thunks/solutions.thunk';
import { renderModel } from '../util/renderModel';

const isEditor = renderModel.isEditor();
const isStudioEditor = renderModel.isStudioEditor();
const locale = renderModel.getLocale();

export const biMiddleware = ({ getState }: MiddlewareAPI<any, TRootState>) => {
  const isDisplayAnswerGen = !isEditor && !isStudioEditor && locale === 'en';
  return (next: Dispatch) => (action: AnyAction) => {
    if (loadSolutions.fulfilled.match(action)) {
      const state = getState();
      if (!isDisplayAnswerGen) {
        logSearchResultsPresented(state, {
          articles: action.payload,
        });
      }
    } else if (chatActions.updateSession.match(action)) {
      const state = getState();
      const {
        chat: { resetReason, conversationId },
      } = state;

      if (resetReason === ResetReason.StartOver && action.payload.conversationId !== conversationId) {
        logChatbotConversationCreatedFromStartOver(state, {
          destinationConversationId: action.payload.conversationId,
        });
      }
    } else if (errorsSlice.actions.addError.match(action) || loadAttaches.rejected.match(action)) {
      if (action.payload?.bi) {
        logChatbotErrorMessageAppears(getState(), action.payload.bi);
      }
    } else if (fieldActions.sendMessage.match(action)) {
      logChatbotSendMessage(getState(), action.payload.bi);
    } else if (loadArticleById.fulfilled.match(action) || loadArticleByUri.fulfilled.match(action)) {
      Promise.resolve().then(() => logSingleArticlePresented(getState(), action.payload));
    } else if (generateAnswerSlice.actions.updateStreamingAnswer.match(action)) {
      const state = getState();
      const solutions = selectSolutions(state) || [];
      logSearchResultsPresented(state, {
        articles: solutions,
      });
    } else if (generateAnswerSlice.actions.failStreamingAnswer.match(action)) {
      const state = getState();
      const solutions = selectSolutions(state) || [];
      logSearchResultsPresented(state, {
        articles: solutions,
      });
    }

    return next(action);
  };
};
